import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CertificationService } from '../services/certification.service';

@Component({
    selector: 'landing',
    templateUrl: './landing.component.html'
})
export class LandingComponent implements OnInit {
    constructor(private activeroute: ActivatedRoute, private router: Router, private certificationService: CertificationService,) { }

    ngOnInit() {
        let refrenceCode = this.activeroute.snapshot.params['c'];
        if (refrenceCode != null) {
            //Validate the Qstring varibale  against the participant ID...
            this.certificationService.validateRefCode(refrenceCode)
                .subscribe((response: any) => {
                    debugger;
                    if (response.pid != 0) {
                        sessionStorage.setItem('Pid', response.pid);
                        sessionStorage.setItem('PName', response.pName);
                        sessionStorage.setItem('Logo', response.logoURL);
                        sessionStorage.setItem('sK', response.skey);
                        sessionStorage.setItem('refCode', refrenceCode);
                        //  this.router.navigate(['form/']);
                        this.router.navigate(['disclaimer']);
                    }
                    else {
                        this.router.navigate(['link/']);
                    }
                });
        }
        else {
            this.router.navigate(['link/']);

        }
    }
}



